import { fetchPassedEvents, resetGameInfo, syncGameInfo } from './actions';

import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { GameInfoSliceState } from './game-info';
import { Team } from 'modules/stream/domain/interfaces/game-info/state';
import { toast } from 'react-toastify';

type ReducerBuilder = ActionReducerMapBuilder<GameInfoSliceState>;

function resetTeam(team: Team) {
  team.members = team.members?.map((member) => {
    return {
      ...member,
      qtyFoulsMatch: 0,
      qtyGoalsMatch: 0,
      qtyRedCardsMatch: 0,
      qtyYellowCardsMatch: 0,
    };
  });
  return team;
}

export function createSyncDataReducer(builder: ReducerBuilder) {
  builder.addCase(syncGameInfo.pending, (state) => {
    state.isSynchronize = false;
    state.isSynchronization = true;
  });

  builder.addCase(syncGameInfo.fulfilled, (state, action) => {
    state.isSynchronize = true;
    state.isSynchronization = false;

    state.goals = action.payload.goals;
    state.fouls = action.payload.fouls;

    // TODO Сделать маппер
    const match = action.payload.gameInfo?.match;
    if (match) {
      state.match = {
        ...match,
        date: match.dateInfo.fullDate,
      };
    }

    const teams = action.payload.gameInfo?.teams;
    if (teams) {
      const first = teams.firstTeam;
      const second = teams.secondTeam;
      if (!first) {
        console.warn({ 'No first team': teams });
        return;
      }
      if (!second) {
        console.warn({ 'No second team': teams });
        return;
      }

      first.members?.concat(second.members ?? []).forEach((member) => {
        if (!member.photo) return;
        const img = new Image();
        img.src = member.photo;
      });

      [first.logo, second.logo].forEach((logo) => {
        if (!logo) return;
        const img = new Image();
        img.src = logo;
      });

      state.teams = {
        first: { ...first },
        second: { ...second },
      };
    }

    const organizer = action.payload.gameInfo?.organizer;
    if (organizer) {
      if (organizer.logo) {
        const img = new Image();
        img.src = organizer.logo;
      }

      state.organizer = { ...organizer };
    }

    const championship = action.payload.gameInfo?.championship;
    if (championship) {
      state.championship = { ...championship };
    }

    console.debug({ event: 'data synchronized' });
  });

  builder.addCase(syncGameInfo.rejected, (state) => {
    state.isSynchronize = false;
    state.isSynchronization = false;
  });
}

export function createResetAllReducer(builder: ReducerBuilder) {
  builder.addCase(resetGameInfo, (state) => {
    state.isSynchronize = false;
    state.isSynchronization = false;

    state.goals = { first: 0, second: 0 };
    state.fouls = [];

    if (state.teams?.first.members) {
      state.teams.first = resetTeam(state.teams.first);
    }
    if (state.teams?.second.members) {
      state.teams.second = resetTeam(state.teams.second);
    }

    state.parsedEventsId = [];
  });
}

export function createFetchPassedEventsReducer(builder: ReducerBuilder) {
  builder.addCase(fetchPassedEvents.fulfilled, (state, action) => {
    state.parsedEventsId = action.payload;
  });

  builder.addCase(fetchPassedEvents.rejected, (state) => {
    toast.error('Не удалось загрузить прошедшие события');
  });
}
